<template>
    <div class="modal show" v-if="this.show">
        <div class="modal-backdrop show" style="z-index: unset" @click.self="close()"></div>
        <section class="modal-dialog">
            <div class="container popup">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">{{ header }}</div>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="close()"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-html="messageHtml"></div>

                    <div class="modal-footer">
                        <button type="button" @click="close()" class="btn btn-secondary">
                            {{ trans('Close') }}
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { emitter } from '../../plugins/Mitt';

export default {
    data() {
        return {
            show: false,
            header: '',
            messageHtml: '',
        };
    },
    methods: {
        close() {
            this.show = false;
        },
    },
    mounted: function () {
        const defaultHeader = trans('Error!');
        emitter.on('show-message-modal', ({ messageHtml, header = defaultHeader }) => {
            this.header = header;
            this.messageHtml = messageHtml;
            this.show = true;
        });
    },
};
</script>
